var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPlayers24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_48671",
    "data-name": "Path 48671",
    d: "M425.3,81.81a2.537,2.537,0,1,1-2.428,2.535A2.483,2.483,0,0,1,425.3,81.81Zm6.5-2.28a3.548,3.548,0,1,1-3.395,3.545A3.472,3.472,0,0,1,431.809,79.53Zm2.939,7.793a.692.692,0,0,0-.207-.031,1,1,0,0,0-.6.213,3.286,3.286,0,0,1-4.224-.021,1,1,0,0,0-.61-.218.64.64,0,0,0-.2.029,6.178,6.178,0,0,0-3.737,5.341c-.092.833.347,2.863,6.623,2.894h.137c6.147,0,6.594-2,6.51-2.83a6.185,6.185,0,0,0-3.694-5.377Zm-10.572,5.2a8.006,8.006,0,0,1,2.071-4.662,2.586,2.586,0,0,1-.93.189,2.465,2.465,0,0,1-1.54-.557.7.7,0,0,0-.591-.135,4.42,4.42,0,0,0-2.729,3.819c-.062.544.211,1.8,3.744,2.029a2.561,2.561,0,0,1-.025-.683Z",
    transform: "translate(-420.449 -79.53)",
    fill: "#116984"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPlayers24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_players24x24.b5cd6c932073d04958a6fa470292c9a9.svg";